import { useParams } from 'react-router-dom';

import VisitAndPeriodReportsTitleTitle from './VisitAndPeriodReportsTitleTitle/VisitAndPeriodReportsTitleTitle';
import PeriodReportsPage from './PeriodReports/PeriodReportsPage';

import { VisitsAndScheduledTasksTableType } from 'components/VisitsAndScheduledTasks/visitsAndScheduledTasks';
import VisitReportsList from 'pages/VisitReports/VisitReportsList';
import { useAppSelector } from 'slices';
import DigestReportList from 'pages/DigestReports/DigestReportList';

interface TabPanelProps {
  children?: React.ReactNode;
  tableName: string;
  currentTable: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, currentTable, tableName } = props;

  return (
    <div hidden={currentTable !== tableName} id={`Table-${tableName}`}>
      {currentTable === tableName && <>{children}</>}
    </div>
  );
}

const VisitAndScheduleTasks: React.FC = () => {
  const { slug } = useParams();
  const currentTable = useAppSelector(state => state.VisitsAndScheduledTasksTable.currentVisitsAndScheduledTasksTable);

  return (
    <div>
      <VisitAndPeriodReportsTitleTitle />
      <CustomTabPanel currentTable={currentTable} tableName={VisitsAndScheduledTasksTableType.VisitReports}>
        <VisitReportsList slug={slug || ''} />
      </CustomTabPanel>
      <CustomTabPanel currentTable={currentTable} tableName={VisitsAndScheduledTasksTableType.PeriodReports}>
        <PeriodReportsPage slug={slug || ''} />
      </CustomTabPanel>
      <CustomTabPanel currentTable={currentTable} tableName={VisitsAndScheduledTasksTableType.DigestReports}>
        <DigestReportList slug={slug || ''} />
      </CustomTabPanel>
    </div>
  );
};

export default VisitAndScheduleTasks;
